<template>
  <div class="aiMatch">
    <div class="search">
  		<van-search 
        placeholder="请输入姓名/职位/城市等" 
        v-model="query" 
        shape="round"
        left-icon=""
        @search="onSearch">
      </van-search>
    </div>
    <div class="filter">
      <van-dropdown-menu>
        <van-dropdown-item :title="cityName || '城市'" ref="cityItem">
          <van-tree-select
            :items="cityList"
            :active-id.sync="expectAreaIds"
            :main-active-index.sync="cityParentIndex"
            @click-item="selectCity"
          />
          <div class="operation">
            <div class="reset" @click="resetCity">重置</div>
            <div class="confirm" @click="confirmCity">确定</div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      <van-dropdown-menu>
      <van-dropdown-item :title="salaryName || '年薪'" v-model="salary" :options="salaryList" ref="salaryItem" @change="changeSalary"/>
      </van-dropdown-menu>
      <van-dropdown-menu >
      <van-dropdown-item :title="degreeName || '学历'" v-model="degree" :options="degreeList" ref="degreeItem" @change="changeDegree"/>
      </van-dropdown-menu>
      <van-dropdown-menu >
      <van-dropdown-item :title="workName || '年限'" v-model="work" :options="workList" ref="workItem" @change="changeWork"/>
      </van-dropdown-menu>
    </div>
    <div class="tag">
      <span @click="changeTags('ifCollege985')" :class="ifCollege985 ? 'cur' : ''">985</span>
      <span @click="changeTags('ifCollege211')" :class="ifCollege211 ? 'cur' : ''">211</span>
      <span @click="changeTags('ifFamousCompany')" :class="ifFamousCompany ? 'cur' : ''">名企</span>
      <span @click="changeTags('ifNetWorkCompany')" :class="ifNetWorkCompany ? 'cur' : ''">知名互联网公司</span>
      <span @click="changeTags('ifWorldTop500')" :class="ifWorldTop500 ? 'cur' : ''">世界500强</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "aiSearch",
  components: {
  	
  },
  data(){
  	return {
      query: this.$route.query.query || '',
      ifCollege985: this.$route.query.ifCollege985 ? true : false,
      ifCollege211: this.$route.query.ifCollege211 ? true : false,
      ifFamousCompany: this.$route.query.ifFamousCompany ? true : false,
      ifNetWorkCompany: this.$route.query.ifNetWorkCompany ? true : false,
      ifWorldTop500: this.$route.query.ifWorldTop500 ? true : false,
      degreeName: '',
      degree: this.$route.query.degreeIds ? ~~this.$route.query.degreeIds : '',
      degreeList: [
        { text: '全部', value: 0 },
        { text: '大专', value: 8},
        { text: '本科', value: 1},
        { text: '硕士', value: 3},
        { text: '博士', value: 4},
        { text: '博士后', value: 5},
        { text: 'MBA', value: 6}
      ],
      workList: [
        { text: '全部', value: 0 },
        { text: '1-3年', value: 1 , minWorkYear: 1, maxWorkYear: 3},
        { text: '3-5年', value: 2 , minWorkYear: 3, maxWorkYear: 5},
        { text: '5-8年', value: 3 , minWorkYear: 5, maxWorkYear: 8},
        { text: '8年以上', value: 4 , minWorkYear: 8}
      ],
      workName: '',
      work: 0,
      cityName: '',
      cityList: [],
      expectAreaIds: 0,
      cityParentIndex: 0,
      salary: 0,
      salaryName: '',
      salaryList: [
        { text: '全部', value: 0 },
        { text: '10万以下', value: 1 , currentAnnualSalaryMax: 8334},
        { text: '10-30万', value: 2 , currentAnnualSalaryMin: 8334, currentAnnualSalaryMax: 25000},
        { text: '30-50万', value: 3 , currentAnnualSalaryMin: 25000, currentAnnualSalaryMax: 41667},
        { text: '50-80万', value: 4 , currentAnnualSalaryMin: 41667, currentAnnualSalaryMax: 66667},
        { text: '80-100万', value: 5 , currentAnnualSalaryMin: 66667, currentAnnualSalaryMax: 83334},
        { text: '100万以上', value: 6 , currentAnnualSalaryMin: 83334}
      ]
  	}
  },
  methods: {
    onSearch(){
      let params = {...this.$route.query};
      params.query = this.query;
      if(!this.query)
        delete params.query;

      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    changeTags(item){
      let params = {...this.$route.query};
      this[item] = !this[item];

      if(this[item]){
        params[item] = this[item];
      }else{
        delete params[item]
      }

      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    changeDegree(value){
      let params = {...this.$route.query};
      this.$refs.degreeItem.toggle(false);
      this.degreeList.forEach(item=>{
        if(item.value == value){
          this.degreeName = item.text == '全部' ? '' : item.text;
        }
      })
      params.degreeIds = value;
      if(!value)
        delete params.degreeIds;

      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    changeWork(value){
      let params = {...this.$route.query};
      let temp = {};
      this.workList.forEach(item=>{
        if(value == item.value){
          this.workName = item.text == '全部' ? '' : item.text;
          temp = item;
        }
      })
      this.$refs.degreeItem.toggle(false);
      params.minWorkYear = temp.minWorkYear;
      params.maxWorkYear = temp.maxWorkYear;
      debugger;
      if(!temp.minWorkYear)
        delete params.minWorkYear;

      if(!temp.maxWorkYear)
        delete params.maxWorkYear;        

      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    confirmCity(){
      let params = {...this.$route.query};
      params.expectAreaIds = this.expectAreaIds;
      if(!this.expectAreaIds)
        delete params.expectAreaIds;

      this.$refs.cityItem.toggle(false);
      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    resetCity(){
      this.cityName = '';
      this.expectAreaIds = 0;
      this.cityList.forEach(item=>{
        item.info = null;
      })
    },
    changeSalary(value){

      let temp = {};
      this.salaryList.forEach(item=>{
        if(item.value == value){
          this.salaryName = item.text == '全部' ? '' : item.text;
          temp = item; 
        }
      })
      let params = {...this.$route.query};
      params.currentAnnualSalaryMin = temp.currentAnnualSalaryMin;
      params.currentAnnualSalaryMax = temp.currentAnnualSalaryMax;
      if(!temp.currentAnnualSalaryMin){
        delete params.currentAnnualSalaryMin;
      }
      if(!temp.currentAnnualSalaryMax){
        delete params.currentAnnualSalaryMax;
      }

      this.$refs.salaryItem.toggle(false);
      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    selectCity(data){

      this.cityName = data.text == '不限' ? data.displayName : data.text;
      this.cityList.forEach((item,index)=>{
        let info = 0;
        item.children.forEach(ch=>{
          if((ch.id == data.id) && (index == this.cityParentIndex)){
            info++;
          }
        })
        item.info = info ? info : null;
      })
    },
    init(){
      if(this.$route.query.currentAnnualSalaryMin || this.$route.query.currentAnnualSalaryMax){
        let min = this.$route.query.currentAnnualSalaryMin ? ~~this.$route.query.currentAnnualSalaryMin : undefined;
        let max = this.$route.query.currentAnnualSalaryMax ? ~~this.$route.query.currentAnnualSalaryMax : undefined;
        this.salaryList.forEach(item=>{
          if(item.currentAnnualSalaryMin == min && item.currentAnnualSalaryMax == max){
            this.salary = item.value;
            this.salaryName = item.text;
          }
        })
      }

      if(this.$route.query.minWorkYear || this.$route.query.maxWorkYear){
        let min = this.$route.query.minWorkYear ? ~~this.$route.query.minWorkYear : undefined;
        let max = this.$route.query.maxWorkYear ? ~~this.$route.query.maxWorkYear : undefined;
        this.workList.forEach(item=>{
          if(item.minWorkYear == min && item.maxWorkYear == max){
            this.work = item.value;
            this.workName = item.text;
          }
        })
      }
    },
    setCity(data){
      let province = JSON.parse(JSON.stringify(data.province)),
          hotCitys = JSON.parse(JSON.stringify(data.positionHotcitys)),
          citys = data.citys;

      let expectAreaIds = this.$route.query.expectAreaIds ? ~~this.$route.query.expectAreaIds : 0;

      province.forEach(pv => {
        pv.text = pv.name;
        pv.info = null;
        pv.citys = pv.citys || [];
        if(pv.citys.length > 1){
          pv.citys.unshift(pv.id);
        }
        let children = [];
        pv.citys.forEach(ct => {
          let item = (ct+'').length == 3 ? {id: ct, name: '不限', displayName: pv.name} : citys[ct];
          item.text = item.name;
          if (ct == expectAreaIds) {
            this.cityName = item.name == '不限' ? item.displayName : item.name;
            pv.info = 1;
          }
          children.push(item);
        });
        pv.children = children;
      });

      hotCitys.forEach(hc => {
        hc.id = hc.code;
        hc.text = hc.name;
      });

      province.unshift({
        id: 0,
        text: "热门城市",
        children: hotCitys
      });

      this.cityList = province;
      this.expectAreaIds = expectAreaIds;
    }
  },
  watch: {
    $route(n,o){

    },
    isChange(n,o){

    },
    cities(n,o){
      if(n){
        this.setCity(n);
      }
    }
  },
  computed: {
    ...mapState({
      cities: state => state.comp.cities || {}
    })
  },
  created() {
    this.init();
    if(window.METADATA){
      this.setCity(window.METADATA);
    }
  }
};
</script>

<style lang="scss" scoped>
  .tag{
    padding: 7px 15px;
    padding-bottom: 0;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    span{
      height: 30px;
      line-height: 28px;
      text-align: center;
      padding: 0 8px;
      font-size: 13px;
      color: #666666;
      background: #F5F5F5;
      border-radius: 4px;
      border: 0.5px solid #F5F5F5;
      white-space: nowrap;
      margin-bottom: 7px;
      &.cur{
        border: 0.5px solid #22BAA5;
        color: #22BAA5;
        background: #fff;
      };
      &:not(:last-child){
        margin-right: 6px;
      }
    }
  }
</style>

<style lang="scss">
.aiMatch{
  .filter{
    .van-sidebar-item--select{
      border-color: #22BAA5;
    }
    .van-tree-select__item--active{
      color: #22BAA5;
    }
    .van-tree-select__selected{
      color: #22BAA5;
    }
    .van-dropdown-item__content{
      max-height: 85%;
    }
    .van-dropdown-menu{
      flex-grow: 1;
    }
    .operation{
      display: flex;
      div{
        font-size: 14px;
        color: #333;
        flex-grow: 1;
        height: 45px;
        line-height: 45px;
        text-align: center;
        &.confirm{
          background: #22BAA5;
          color: #fff;
        }
        &.reset{
          box-shadow: inset 0 1px 0 0 #ddd;
        }
      }
    }
  }
  .search{
    .van-dropdown-item__content{
      max-height: 85%;
    }

    .van-search{
      padding: 7px 10px;
      .van-cell{
        padding: 3px 8px 3px 0;
      }
    }
    .van-dropdown-menu{
      height: 30px;
    }
    .van-dropdown-menu__title{
      .van-ellipsis{
        max-width: 30px;
      }
    }
    .van-search__label{
      padding: 0 15px 0 10px;
      margin-right: 10px;
      position: relative;
      line-height: 30px;
      &:after{
        content: " ";
        position: absolute;
        right: 0;
        top: 50%;
        width: 1px;
        height: 40%;
        background-color: #e5e5e5;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      };
    }
    .van-tree-select__item{
      
    }
  }
}
</style>
